import LocationAdapter from "@javascripts/adapters/location_adapter";

export default class HideController {
  constructor({ tech, data } = {}) {
    this._tech = tech;
    this._data = data;
  }

  tech() {
    return this._tech;
  }

  data() {
    return this._data;
  }

  shouldInit() {
    return this.data().embed() == 'true' && LocationAdapter.search()['hide_controller'] == 'true'
  }

  init() {
    this.tech().videoContainer().querySelector('.vjs-progress-control')?.classList?.add('vjs-hidden');
    this.tech().videoContainer().querySelector('.vjs-remaining-time')?.classList?.add('vjs-hidden');
    this.tech().videoContainer().querySelector('.vjs-bitrate-switcher')?.classList?.add('vjs-hidden');
  }
}
